import React from 'react';
import { Steps, Collapse, Space, Card } from 'antd';
import { useEffect, useState } from 'react';
import { getApprovalInfoReq } from './taskNode'
import './index.scss'

const { Step } = Steps;
const { Panel } = Collapse;
export const GrtWorkTaskNode = (props) => {
  const { Panel } = Collapse,
    { Step } = Steps;
  const { pageId, statusData: { task_id = '', proc_inst_id = '' } } = props;
  const progressMap = {
    submit: { text: '已提交', color: 'green' },
    agree: { text: '已同意', color: 'green' },
    pending: { text: '处理中', color: 'orange' },
    disagree: { text: '拒绝', color: 'red' }
  };
  const [curStepNum, setCurStepNum] = useState(0);
  const [approvalInfo, setApprovalInfo] = useState(
    {
      "tasks": [
        {
          "task_id": "1594972195220033536",
          "task_name": "提交人",
          "task_status": "submit",
          "approvers": [
            {
              "id": "1",
              "name": "管理员",
              "head_portrait": "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif",
              "approve_time": "2022-11-22 16:32:59",
              "comment": null,
              "approve_status": "submit"
            }
          ]
        },
        {
          "task_id": "Activity_1l13qob",
          "task_name": null,
          "task_status": "pending",
          "approvers": []
        }
      ]
    }
  );
  const getApprovalInfo = () => {
    const json = {
      task_id: task_id,
      proc_inst_id: proc_inst_id
    };

    getApprovalInfoReq(json).then((res) => {
      if (res.data) {
        setApprovalInfo(res.data);
        //计算steps进度条
        let curStep = res.data.tasks.reduce((prev, cur) => (cur.approve_status !== 'pending' ? (prev += 1) : null), 0);

        setCurStepNum(curStep);
      }
    });
  };

  useEffect(() => {
    if (pageId && proc_inst_id && task_id) {
      getApprovalInfo()
    }
  }, [pageId, proc_inst_id, task_id]);
  return (
    <div className="content">
      {/*    审批进度*/}
      <Card title="审批进度">
        <Steps progressDot current={curStepNum} direction="vertical">
          {approvalInfo && approvalInfo.tasks.map((v) => (
            <Step
              key={v.task_id}
              title={
                <Collapse defaultActiveKey={[v.task_id]} expandIconPosition="end" ghost>
                  <Panel
                    header={
                      <Space>
                        <p className='title-text'>{v.task_name}</p>
                        <p className='title-text'>{progressMap[v.task_status].text}</p>
                      </Space>
                    }
                    key={v.task_id}
                  >
                    {v.approvers && v.approvers.length
                      ? v.approvers.map((vs) => (
                        <div key={vs.id} className='panel-item'>
                          <div className='panel-content'>
                            <div className='left'>
                              <Space>
                                <img src={vs.head_portrait} alt="" />
                                {vs.name}
                              </Space>
                            </div>
                            <div className='right'>
                              {vs.approve_status ? (
                                <Space>
                                  <span
                                    style={{
                                      color: progressMap[vs.approve_status].color
                                    }}
                                  >
                                    {progressMap[vs.approve_status].text}
                                  </span>
                                  <span>{vs.approve_time}</span>
                                </Space>
                              ) : null}
                            </div>
                          </div>
                          <div className='panel-footer'>{vs.comment ? `审批意见：${vs.comment}` : ''}</div>
                        </div>
                      ))
                      : null}
                  </Panel>
                </Collapse>
              }
            />
          ))}
        </Steps>
      </Card>
    </div>
  );
};

